import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabaseClient";
import { checkAndUpdateTokens } from '../Data/betdata/CheckAndUpdateTokens.jsx';
import Logo from '../Components/Logo.jsx';
import { ForgotPasswordPopup } from "../Data";
import { motion } from "framer-motion";

function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [loginHover, setLoginHover] = useState(false);
  const [registerHover, setRegisterHover] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const blueButtonStyle = {
    backgroundColor: loginHover ? "blue" : "#010286",
    color: "white",
  };
  const registerBtn = {
    backgroundColor: registerHover ? "#198754" : "#010286",
    color: "white",
  };
const togglePasswordVisibility = () => {
  setShowPassword(!showPassword);
};
  const loginHandler = async () => {
    if (!email || !password) {
      alert("Please fill in both email and password");
      return;
    }

    const { user, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      alert(error.message);
      return;
    }

    if (user) {
      navigate("/FriendlyBets");
    } else {
      const {
        data: { session },
      } = await supabase.auth.getSession();

      if (session && session.user) {
        checkAndUpdateTokens();
        navigate("/FriendlyBets");
      }
    }
  };

  const registerHandler = () => {
    navigate("/register");
  };

  return (
    <div className="auth-page">
      <Logo />
      <motion.div
        className="auth-card fb-card"
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3, ease: "easeOut" }}
      >
        <div className="auth-card__body">
          <h3 className="auth-card__title">Sign In Here!</h3>
          <div className="auth-field-wrap">
            <label htmlFor="userName" className="auth-label">
              Email address
            </label>
            <input
              type="text"
              className="auth-input"
              id="userName"
              placeholder="Email"
              onChange={(event) => setEmail(event.target.value)}
            />
          </div>
          <div className="auth-field-wrap auth-password-wrap">
            <label htmlFor="password" className="auth-label">
              Password
            </label>
            <input
              type={showPassword ? "text" : "password"}
              className="auth-input"
              id="password"
              placeholder="Enter Password"
              onChange={(event) => setPassword(event.target.value)}
            />
            <span
              onClick={togglePasswordVisibility}
              className="auth-password-toggle"
            >
              {showPassword ? "👁️" : "👁️‍🗨️"}
            </span>
          </div>
          <div className="auth-actions">
            <button
              className="fb-btn"
              type="button"
              style={blueButtonStyle}
              onMouseEnter={() => setLoginHover(true)}
              onMouseLeave={() => setLoginHover(false)}
              onClick={loginHandler}
            >
              Login
            </button>
            <button
              className="fb-btn"
              type="button"
              style={registerBtn}
              onMouseEnter={() => setRegisterHover(true)}
              onMouseLeave={() => setRegisterHover(false)}
              onClick={registerHandler}
            >
              Register
            </button>
            <button
              className="auth-link-button"
              onClick={() => setShowForgotPassword(true)}
            >
              Forgot Password?
            </button>
          </div>
        </div>
        {showForgotPassword && (
          <ForgotPasswordPopup onClose={() => setShowForgotPassword(false)} />
        )}
      </motion.div>
    </div>
  );
}

export {Login}

